import { HomeContainerWithoutAside, HomeContentWithoutAside } from 'Modules/Home/HomeLayouts';

function NotSetup() {
  return (
    <HomeContainerWithoutAside data-testid="not-setup">
      <HomeContentWithoutAside
        title="NOT CONFIGURED"
        info="Kobai has not been configured or has been incorrectly configured. Please contact your administrator to setup and configure Kobai."
        infoProps={{ className: 'tw:w-[415px]' }}
      />
    </HomeContainerWithoutAside>
  );
}

export default NotSetup;
